import { metrics } from '@atlassian/browser-metrics';

export const legacyIssueCreateInitialRenderInteraction = metrics.interaction({
	key: 'legacy-issue-create.initial-render',
});

export const legacyIssueCreateTransitionInteraction = metrics.interaction({
	key: 'legacy-issue-create.transition',
});

export const legacyIssueCreateCombinedInteraction = metrics.interaction({
	key: 'legacy-issue-create.combined',
});
